/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const TickIcon: React.SFC = () => {
    return (
        <svg width="20" height="20">
          <g fill="none" fillRule="evenodd">
            <rect fill="#F07662" width="20" height="20" rx="2"/>
            <path d="M8.4446142 14.5553858l.0434295.0434295 7.1107716-7.1107716L14.1107716 6 8.413732 11.6970397 6.716692 10 5 11.716692l3.141654 3.141654.3029602-.3029602z" fill="#FFF"/>
          </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Tick/Tick.tsx